import type { ButtonSize } from '@consumer/components/GButton.vue'
import type { IconSize } from '@consumer/components/GIcon.vue'

export type { IconSize }

const iconSizes: Record<string, IconSize> = {
  xsmall: 'xs',
  small: 'sm',
  medium: 'sm',
  large: 'sm',
  default: 'sm',
} as const

export const flatIconSizes: Record<string, IconSize> = {
  xsmall: 'sm',
  small: 'sm',
  medium: 'md',
  large: 'md',
  default: 'md',
} as const

const loadingIconSizes: Record<string, IconSize> = {
  xsmall: 'xs',
  small: 'sm',
  medium: 'md',
  large: 'md',
  default: 'md',
} as const

export function iconSizeForButton (size: ButtonSize, flat?: boolean): IconSize {
  return (flat ? flatIconSizes[size as any] : iconSizes[size as any]) || size as any
}

export function loadingIconSizeForButton (size: ButtonSize, flat?: boolean): IconSize {
  return (flat ? flatIconSizes[size as any] : loadingIconSizes[size as any]) || size as any
}
